const headers = {
  'Content-Type': 'application/json',
  'Cache-Control': 'no-cache', 
  'Pragma': 'no-cache',
};

const SERVER = '/api'
export class EmblemApi {

  static async getNewDesignRequest() {
    const resp = await fetch(`${SERVER}/v3/design-requests/new-design-request`, {
      method: 'GET',
      headers: headers
    })
    const data = await resp.json()
    return data.response.designRequest
  }

  static async getSteps(designRequest?: unknown) {
    const reqData = JSON.stringify(designRequest)
    const resp = await fetch(`${SERVER}/v3/design-requests/steps`, {
      method: 'POST',
      headers: headers,
      body: reqData
    })
    const data = await resp.json()
    return data.response?.steps
  }
}
